import _ from 'lodash'
import { Concept } from './Concept'
import { ConceptStatusValidity, ValidityDeterminate } from '@fusion-advantage/backcompat'

export enum ValiditySeverity {
	Success = 'success',
	Warning = 'warning',
	Error = 'error',
}

export class ConceptStatusValidityInfo {
	validity: ConceptStatusValidity

	constructor(validity: ConceptStatusValidity) {
		this.validity = validity
	}

	get severity(): ValiditySeverity {
		switch(this.validity.determinate) {
			case ValidityDeterminate.Invalid:
				return ValiditySeverity.Error
			case ValidityDeterminate.Abnormal:
				return ValiditySeverity.Warning
			case ValidityDeterminate.OutOfRange:
				return ValiditySeverity.Error
			case ValidityDeterminate.Required:
				return ValiditySeverity.Error
		}
		return ValiditySeverity.Success
	}

	message(concept: Concept): string {
		if(this.validity.message) {
			return this.validity.message
		}
		switch(this.validity.determinate) {
			case ValidityDeterminate.Invalid:
				return `Invalid value for "${concept.title}"`
			case ValidityDeterminate.Abnormal:
				return `Abnormal value for "${concept.title}"`
			case ValidityDeterminate.OutOfRange:
				return `Out of range value for "${concept.title}"`
			case ValidityDeterminate.Required:
				return `Value required for "${concept.title}"`
		}
		return 'Valid value'
	}
}
